"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HammerOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M15.48 25a1 1 0 001 1 1 1 0 10-1-1z"/><path d="M28.38 6a5 5 0 00-4-2h-.58A3 3 0 0021 2h-9a3 3 0 00-3 3h-.06a2.52 2.52 0 00-2.46-2h-1A2.51 2.51 0 003 5.51v5A2.52 2.52 0 005.52 13h1a2.52 2.52 0 002.46-2H9a3 3 0 003 3h.88L12 25.35v.16a4.4 4.4 0 002.54 4.07A4.53 4.53 0 0021 25.5v-.15L20.12 14H21a3 3 0 003-3v-1h.67l.8.26a2.49 2.49 0 00.85.14A2.69 2.69 0 0029 8.16 2.81 2.81 0 0028.38 6zM19 25.5a2.5 2.5 0 11-5 0l.87-11.5h3.22zm7.3-17.1h-.23l-.79-.27a1.93 1.93 0 00-.63-.1H23a1 1 0 00-1 1v2a1 1 0 01-1 1h-9a1 1 0 01-1-1V10a1 1 0 00-1-1H8a1 1 0 00-1 1v.48a.52.52 0 01-.52.52h-1a.52.52 0 01-.48-.52v-5A.52.52 0 015.52 5h1a.52.52 0 01.48.52V6a1 1 0 001 1h2a1 1 0 001-1V5a1 1 0 011-1h9a1 1 0 011 1 1 1 0 001 1h1.39a3 3 0 012.49 1.34.68.68 0 01-.58 1.06z"/>';
var HammerOutlineSVG = function HammerOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HammerOutlineSVG = HammerOutlineSVG;
HammerOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HammerOutlineSVG);
exports.default = _default;